import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import useIntersectionObserver from '~hooks/useIntersectionObserver';
import useMedia from '~hooks/useMedia';

import { MENU_TYPE } from '../constants';
import LNB from '../LNB';
import SubCategoryTabs from '../LNB/SubCategoryTabs';
import Ranking from '../Ranking';
import { useGetCatetoryIndustriesMenu } from '../Ranking/hooks';
import { useGetMenuByParams } from './hooks';
import * as S from './style';

export default function RankingContents() {
  const stickyRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const { isDesktop } = useMedia();
  const defaultSelectedMenu = useGetMenuByParams();
  const [selectedMenu, setSelectedMenu] = useState<MENU_TYPE>(defaultSelectedMenu);
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<string>('TOTAL');
  const industriesMenu = useGetCatetoryIndustriesMenu(selectedMenu);
  const entry = useIntersectionObserver(stickyRef, {
    root: null,
    rootMargin: '-55px 0px 0px',
    threshold: 0,
  });

  const handleClickSubCategory = (subCategoryId: string) => {
    const params = new URLSearchParams({ selectedMenu, subCategory: subCategoryId });
    setSelectedSubCategoryId(subCategoryId);

    router.replace(
      {
        pathname: '/',
        search: params.toString(),
      },
      undefined,
      { scroll: false },
    );
  };

  useEffect(() => {
    if (router.isReady) {
      setSelectedMenu(defaultSelectedMenu ?? 'DALIY_VIEW_RANK');
    }
  }, [defaultSelectedMenu, router]);

  useEffect(() => {
    setSelectedSubCategoryId((router.query.subCategory as string) ?? 'TOTAL');
  }, [router.query]);

  return (
    <>
      <div ref={stickyRef} />
      <S.Wrapper hasSubCategory={industriesMenu && industriesMenu.length > 0}>
        {router.isReady && (
          <>
            <S.StickyWrapper sticky={!entry?.isIntersecting}>
              <S.LNBWrapper>
                <LNB selectedMenu={selectedMenu} setSelectedMenu={setSelectedMenu} />
              </S.LNBWrapper>
              {!isDesktop && industriesMenu && industriesMenu.length > 0 && (
                <SubCategoryTabs
                  selectedMenuId={selectedSubCategoryId}
                  menuList={industriesMenu}
                  onClick={handleClickSubCategory}
                />
              )}
            </S.StickyWrapper>
            <Ranking selectedMenu={selectedMenu} />
          </>
        )}
      </S.Wrapper>
    </>
  );
}
